import initHeader from './modules/header';
import initLottie from './modules/lottie';
import initM3 from './modules/m3';
import initM5 from './modules/m5';
import initM7 from './modules/m7';
import initM9 from './modules/m9';
import initM11 from './modules/m11';
import initM12 from './modules/m12';
import initM13 from './modules/m13';
import initM18 from './modules/m18';
import initM21 from './modules/m21';
import initM22 from './modules/m22';
import initM23 from './modules/m23';
import initM25 from './modules/m25';
import initWorkHandler from './modules/work-handler';
import initFilter from './modules/filter';
import initM1 from './modules/m1';
import initPortfolio from './modules/portfolio';
import initM33 from './modules/m33';
import initWork from './pages/page-work';

initHeader()
initLottie()
initM1()
initM3()
initM5()
initM7()
initM9()
initM11()
initM12()
initM13()
initM18()
initM21()
initM22()
initM23()
initM25()
initPortfolio()
initWorkHandler()
initFilter()
initM33()
initWork();
